import TimeSlot from '@/models/date-picker/TimeSlot';

export default class DateUtils {
  public static getDaySuffix(day: number): string {
    switch (day) {
      case 1:
      case 21:
      case 31:
        return 'st';
      case 2:
      case 22:
        return 'nd';
      case 3:
      case 23:
        return 'rd';
      default:
        return 'th';
    }
  }

  public static getTimeSuffix(hours: number): string {
    return hours < 12 ? 'am' : 'pm';
  }

  public static getTime12HourFormatted(date: Date): string {
    const time = date.getHours() % 12;

    return `${time === 0 ? 12 : time}${this.getTimeSuffix(date.getHours())}`;
  }

  public static getDateFormatted(date: Date, includeWeekday: boolean = false, includeYear: boolean = false): string {
    if (!date) {
      return '';
    }

    const weekday = date.toLocaleDateString('en-GB', { weekday: 'long' });
    const day = `${date.getDate()}${DateUtils.getDaySuffix(date.getDate())}`;
    const month = `${date.toLocaleDateString('en-GB', { month: 'long' })}`;

    return `${includeWeekday ? weekday : ''} ${day} ${month} ${includeYear ? date.getFullYear() : ''}`;
  }

  public static addDays(days: number): Date {
    const date = new Date();
    date.setDate(date.getDate() + days);

    return date;
  }

  public static isSameDay(first: Date, second: Date): boolean {
    return first.getFullYear() === second.getFullYear()
      && first.getMonth() === second.getMonth()
      && first.getDate() === second.getDate();
  }

  public static getTimeSlots(date: Date): TimeSlot[] {
    const slots: TimeSlot[] = [];
    const interval = 60;

    // 9am to 5pm
    for (let minutes = 9 * 60; minutes < 17 * 60; minutes += interval) {
      const startDate = new Date(date);
      startDate.setHours(0);
      startDate.setMinutes(minutes);

      const endDate = new Date(startDate);
      endDate.setMinutes(interval);

      slots.push(new TimeSlot(minutes, startDate, endDate));
    }

    return slots;
  }
}
